import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ listGap: string; listPadding: string }>`
  ${({ listGap, listPadding, theme }) => css`
    cursor: grab;
    white-space: nowrap;
    overflow: hidden;
    display: inline-flex;
    flex-direction: row;
    gap: ${listGap || theme.spacing.km4};
    padding: ${listPadding || `0`};
    width: 100%;
    :hover {
      overflow: auto;
    }

    :active {
      cursor: grabbing;
    }

    ::-webkit-scrollbar {
      display: none;
    }
  `}
`;
